import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Race17() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "race17";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
        gameName={"Race To 17"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container raceto17"> */}
      {/* <div className="casino-header">
              <span className="casino-name">
                Race to 17
                <a className="ms-1">
                  <small>Rules</small>
                </a>
              </span>
              <span className="casino-rid d-none d-xl-inline-block">
                <small>
                  Round ID: <span>139250425210834</span>
                </small>
              </span>
            </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
              <ul className="nav nav-tabs menu-tabs">
                <li className="nav-item">
                  <div className="nav-link active">Game</div>
                </li>
                <li className="nav-item">
                  <div className="nav-link">Placed Bet (0)</div>
                </li>
              </ul>
              <div className="pe-2">
                <span className="casino-rid">
                  Round ID: <span>139250425210834</span>
                </span>
              </div>
            </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/race17/c4d1e220-64f2-4cca-b12c-f7fb23e1dae5?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
                  <h5>Total: 16</h5>
                  <div className="mt-1">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9SS.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9SS.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/3HH.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/3HH.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/4SS.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/4SS.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Race to 17</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Race To 17", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Race To 17", casinoData, true)} 
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Race To 17", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Race To 17", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Race To 17")}
              </div>
            </div>
            
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                {" "}
                {casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName}
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <span className="casino-odds">
                  {" "}
                  {/* {getOddForEntity("Big Card (7,8,9) - 5", casinoData, true)} */}
                  {getOddForEntity(
                    casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName,
                    casinoData,
                    dispatch,
                    "lay"
                  )
                }
              >
                <span className="casino-odds">
                  {" "}
                  {/* {getOddForEntity("Big Card (7,8,9) - 5", casinoData, false)} */}
                  {getOddForEntity(
                    casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName,
                    casinoData,
                    false
                  )}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName"
                  // "Big Card (7,8,9) - 5"
                )}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                {casinoData?.data?.response?.oddDetailsDTOS?.[2]?.runnerName}
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.oddDetailsDTOS?.[2]?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity(
                    casinoData?.data?.response?.oddDetailsDTOS?.[2]?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.oddDetailsDTOS?.[2]?.runnerName,
                    casinoData,
                    dispatch,
                    "lay"
                  )
                }
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity(
                    casinoData?.data?.response?.oddDetailsDTOS?.[2]?.runnerName,
                    casinoData,
                    false
                  )}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {/* {getCasinoPlExposureByRunner(casinoPlData, "Zero Card - 3")} */}
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.oddDetailsDTOS?.[2]?.runnerName"
                )}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Any Zero</div>
              {/* <div className="casino-odds-box back suspended-box"> */}
              <div
                className={`casino-odds-box back ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Any Zero", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Any Zero", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay suspended-box"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Any Zero", casinoData, dispatch, "lay")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Any Zero", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Any Zero")}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
          <span>Last Result</span>
          <span>
            <a href="/casino-results/race17">View All</a>
          </span>
        </div> */}
        {/* <div className="casino-last-results">
          <span className="result result-a">N</span>
          <span className="result result-b">Y</span>
          <span className="result result-a">N</span>
          <span className="result result-a">N</span>
          <span className="result result-a">N</span>
          <span className="result result-b">Y</span>
          <span className="result result-b">Y</span>
          <span className="result result-a">N</span>
          <span className="result result-b">Y</span>
          <span className="result result-b">Y</span>
        </div> */}
      </div>
      {/* </div> */}
      {/* <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div> */}
      {/* </div> */}
      {/* </div> */}

      {/* </div> */}
    </CasinoPage>
  );
}
